/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderItemUpdateDto
 */
export interface OrderItemUpdateDto {
    /**
     * Order item ID
     * @type {number}
     * @memberof OrderItemUpdateDto
     */
    itemId: number;
    /**
     * Item quantity
     * @type {number}
     * @memberof OrderItemUpdateDto
     */
    quantity: number;
    /**
     * Item unit price
     * @type {number}
     * @memberof OrderItemUpdateDto
     */
    unitPrice: number;
}

/**
 * Check if a given object implements the OrderItemUpdateDto interface.
 */
export function instanceOfOrderItemUpdateDto(value: object): value is OrderItemUpdateDto {
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPrice' in value) || value['unitPrice'] === undefined) return false;
    return true;
}

export function OrderItemUpdateDtoFromJSON(json: any): OrderItemUpdateDto {
    return OrderItemUpdateDtoFromJSONTyped(json, false);
}

export function OrderItemUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'itemId': json['itemId'],
        'quantity': json['quantity'],
        'unitPrice': json['unitPrice'],
    };
}

export function OrderItemUpdateDtoToJSON(value?: OrderItemUpdateDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'itemId': value['itemId'],
        'quantity': value['quantity'],
        'unitPrice': value['unitPrice'],
    };
}

